<app-content>
  <app-breadcrumbs>
    <li>
      <a href="/konsultacje-spoleczne">Konsultacje społeczne</a>
    </li>
    <li>
      {{ survey.title }}
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      {{ survey.title }}
    </h2>
    <div class="gov-card">
      <div class="gov-card__header">
        Konsultacja nr 1/2025 @if (!!survey.active && !survey.publishResults) {
        <span class="ms-1 color--green d-inline-flex align-items-center">
                    <i aria-hidden="true" class="fa fa-info-circle me-2"></i><small style="margin-bottom: 0.15rem">(Konsultowane)</small>
                  </span>
      } @else {
        <span class="ms-1 color--light-blue d-inline-flex align-items-center">
                    <i aria-hidden="true" class="fa fa-info-circle me-2"></i><small style="margin-bottom: 0.15rem">(Opublikowano wyniki)</small>
                  </span>
      }
        @if (!survey.active) {
          <span class="ms-1 color--dark-red d-inline-flex align-items-center">
                    <i aria-hidden="true" class="fa fa-info-circle me-2"></i><small style="margin-bottom: 0.15rem">(Nie aktywna)</small>
                  </span>
        }
      </div>
      <div class="gov-card__body">
        <div class="row">
          <div class="col-md-3">
            <app-label label="Data rozpoczęcia:">1.12.2025</app-label>
          </div>
          <div class="col-md-3">
            <app-label label="Data zakończenia:">31.12.2025</app-label>
          </div>
          <div class="col-12">
            <app-label label="Kategoria:">Infrastruktura rekreacyjna</app-label>
          </div>
          <div class="col-12">
            <app-label label="Typ konsultacji:">Ankieta</app-label>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-12">
            <div class="editor-content" [innerHTML]="survey.description"></div>
          </div>
        </div>
      </div>
    </div>
    <br>
    @if (survey.publishResults) {
      <app-alert [closable]="false">
        <strong>Opublikowano wyniki!</strong> Już nie możesz wziąć udział w głosowaniu.
        <a routerLink="../" class="ms-2"><strong>Powrót do listy</strong></a>
      </app-alert>
    }
    @if (survey.userHasAnswered) {
      <app-alert [closable]="false" type="danger">
        Oddales już swój głos!
      </app-alert>
    }
    @if (form.questions.length) {
      <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
        <ng-container formArrayName="questions">
          @for (item of survey.surveyQuestions; track $index) {
            @if (form.getFormGroup($index); as formGroup) {
              <fieldset [formGroup]="formGroup">
                <legend>
                  {{ item.title }}
                </legend>
                @if (item?.type?.code === 'textarea') {
                  <div class="row">
                    <div class="col-12">
                      @if ("text"; as controlName) {
                        <div class='form-group'>
                          <label
                            [for]="item.uuid">Odpowiedź @if (formGroup.get(controlName)?.hasValidator(form.validators.required)) {
                            *
                          }</label>
                          <textarea
                            [ngClass]='{ "is-invalid": form.showControlError(formGroup.get(controlName)) }'
                            [id]="item.uuid"
                            rows='4'
                            [formControlName]='controlName'
                            autocomplete='off'
                            placeholder='Wpisz tu odpowiedź'
                            type='text'>
                          </textarea>
                          <app-validation-errors [control]='formGroup.get(controlName)'>
                          </app-validation-errors>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (item?.type?.code === 'checkbox') {
                  <br>
                  <div class="row" formArrayName="choices">
                    <div class="col-12">
                      <div class='form-group'>
                        @for (choice of item?.surveyQuestionChoices; track $index) {
                          <div class='custom-checkbox custom-block'
                               [ngClass]='{ "is-invalid": form.showControlError(formGroup.get(controlName)) }'
                               *ngIf='$index + "" as controlName'>
                            <input
                              #input
                              (change)="form.checkBoxChange(input?.checked ? $event : null, $index, formGroup)"
                              [value]='choice.uuid'
                              [formControlName]='controlName'
                              type='checkbox'
                              [id]='choice.uuid'
                              [name]='controlName'>
                            <label [for]='choice.uuid'>
                              {{ choice.title }}
                            </label>
                          </div>
                          <app-validation-errors [control]='form.get($index + "")'>
                          </app-validation-errors>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if (item?.type?.code === 'radio') {
                  @if (form.questions.at($index).status === 'INVALID' && this.form.touched) {
                    <app-alert class="d-inline-block" alertTitle="Uwaga!" type="danger" [closable]="false">
                      Wymagane zaznaczenie minimum 1 pozycji.
                    </app-alert>
                  } @else {
                    <br>
                  }
                  <div class="row" formArrayName="choices">
                    <div class="col-12">
                      <div class="form-group">
                        @for (choice of item?.surveyQuestionChoices; track $index) {
                          <div class="custom-radio custom-block">
                            <input
                              [formControlName]='0 + ""'
                              [value]="choice.uuid"
                              type="radio"
                              [id]="choice.uuid">
                            <label [for]="choice.uuid">
                              {{ choice.title }}
                            </label>
                          </div>
                          <app-validation-errors [control]='form.get($index + "")'>
                          </app-validation-errors>
                        }
                      </div>
                    </div>
                  </div>
                }
              </fieldset>
            }
          }
        </ng-container>
        @if (!authed) {
          <div class="row">
            <div class="col-12">
              <app-alert [closable]="false">
                Głosowanie w konsultacjach społecznych wymaga zalogowania. <strong>Zaloguj się, aby wziąć
                udział!</strong>
              </app-alert>
            </div>
          </div>
        }
        <div class="d-flex justify-content-end mt-5">
          <button
            routerLink="../"
            type='button'
            class='btn btn-secondary me-3'>
            <span>
              Wstecz
            </span>
          </button>
          @if (!survey.userHasAnswered && authed) {
            <button
              [disabled]="pending() || survey.publishResults"
              type='submit'
              class='btn btn-primary'>
              <span>Wyślij</span>
            </button>
          }
        </div>
      </form>
    }
  </section>
</app-content>
